import { Donuz } from "donuz-js/Donuz";
// @ is an alias to /src
export default {
    name: "voucher",
    data() {
        return {
            obj: {},
            voucher: {},
            client: {}
        };
    },
    methods: {
        imprimir() {
            window.print();
        }
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
        let result = await Donuz.redeemption.getRedeemption(
            this.$route.params.id.split("-")[1],
            sessionStorage.getItem(btoa("tokenCliente"))
        );
        if (result.status == 200) {
            this.voucher = result.resgates[0];
        }
    }
};